/* تحويل الأرقام العربية/الفارسية إلى إنجليزية — يستخدم في الهواتف والأسعار */
export const toLatinDigits = (s) =>
  String(s ?? "")
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

export const normalizePhoneInput = (s) => toLatinDigits(s).replace(/[^0-9+\s-]/g, "");
